module.exports = __webpack_public_path__ + "static/img/224_TO8_1955.c0215c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/224_TO8_1955.jpg
// module id = j4JE
// module chunks = 0